import { chProgressNoteFragment$data } from "@/modules/patients/services/ch/__generated__/chProgressNoteFragment.graphql"
import { Service } from "@/types/__generated__/union-types"

type MeasAppointment = Pick<NonNullable<chProgressNoteFragment$data["followUpAppointment"]>, "service" | "partnerType">

export const MEDGATE_CONNECT_SERVICE: Service = "MEDGATE_CONNECT"

export const isMedgateConnect = (service: Service): boolean => service === MEDGATE_CONNECT_SERVICE

export const isMeasMedgateConnectAppointment = (appointment: MeasAppointment | null): boolean =>
  appointment !== null && isMedgateConnect(appointment.service) && appointment.partnerType === "MEAS"
